// import React, { useEffect, useState } from 'react';
// import classes from "./MatchWinningsPage2.module.css";
// import { FaArrowLeft, FaTrophy, FaMinus, FaCheck } from 'react-icons/fa6';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { toast } from 'react-toastify';
// import moment from 'moment-timezone';
// import { matchWinningsApi, getPredictionLeaderboardApi } from '../../http/http';
// import SmallLoader from '../../component/SmallLoader';
// import { removeUserDetails } from '../../store/slices/userSlice';

// /* ── helpers ── */
// const safeParse = (raw, fb = null) => {
//     try { return raw ? JSON.parse(raw) : fb; }
//     catch { return fb; }
// };

// const MEDAL = { 1: "🥇", 2: "🥈", 3: "🥉" };

// const getRankDisplay = (rank) => {
//     if (rank === 1) return { emoji: "🥇", label: "1st Place", gold: true };
//     if (rank === 2) return { emoji: "🥈", label: "2nd Place", gold: false };
//     if (rank === 3) return { emoji: "🥉", label: "3rd Place", gold: false };
//     return { emoji: null, label: `#${rank}`, gold: false };
// };

// /* ─── Safe parse ─── */
// // const safeParse = (raw, fb = []) => {
// //     try {
// //         const p = typeof raw === 'string' ? JSON.parse(raw) : raw;
// //         return Array.isArray(p) ? p : fb;
// //     } catch { return fb; }
// // };

// const GOAL_TIME_LABELS = {
//     "0-15": "0 – 15 min",
//     "16-30": "16 – 30 min",
//     "31-45": "31 – 45 min",
//     "46-60": "46 – 60 min",
//     "61-75": "61 – 75 min",
//     "76-90": "76 – 90 min",
//     "none": "No Goal",
// };

// /* ════════════════════════════════════
//    COMPONENT
// ════════════════════════════════════ */
// const MatchWinningsPage2 = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { userDetails } = useSelector(s => s?.persisted?.userSlice);

//     const [winning, setWinning] = useState(null);
//     const [leaderboard, setLeaderboard] = useState([]);
//     const [userRank, setUserRank] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [tab, setTab] = useState("winnings");

//     const [predictions, setPredictions] = useState([]);






//     /* ── fetch ── */
//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const fixtureId = location?.state?.match_fixture_id;

//             const [winRes, lbRes] = await Promise.all([
//                 matchWinningsApi(fixtureId, userDetails?.token),
//                 getPredictionLeaderboardApi(fixtureId, userDetails?.token),
//             ]);

//             // matchWinningsApi returns single user winning row (or array)
//             const winData = winRes?.data;
//             setWinning(Array.isArray(winData) ? winData[0] : winData);

//             let d = Array.isArray(winData) ? winData[0] : winData

//             setPredictions(safeParse(d?.predictions));

//             setLeaderboard(lbRes?.data?.leaderboard ?? []);
//             setUserRank(lbRes?.data?.userRank?.[0] ?? null);

//         } catch (e) {
//             if (e?.response?.status === 403) {
//                 dispatch(removeUserDetails());
//                 toast.error("Login Again!");
//                 navigate('/');
//             } else {
//                 toast.error(e?.response?.data?.message || "Something Went Wrong!");
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (location?.state?.match_fixture_id) fetchData();
//         else navigate(-1);
//     }, [location?.state?.match_fixture_id]);

//     /* ── derived from winning ── */
//     const matchDetails = safeParse(winning?.match_details);
//     const homeGoals = matchDetails?.goals?.home ?? null;
//     const awayGoals = matchDetails?.goals?.away ?? null;
//     const rank = winning ? getRankDisplay(winning.user_rank) : null;

//     console.log(matchDetails,'md');

//     /* ── extract typed predictions ── */
//     const getPred = (key) => predictions?.find(p => p[key])?.[key];
//     const scorers = getPred('scorers') ?? [];
//     const halfTime = getPred('halfTime') ?? null;
//     const winner = getPred('winner') ?? null;

//     console.log(halfTime,'ht')

//     const firstGoalRaw = getPred('firstGoal') ?? null;
//     const firstGoalValue = typeof firstGoalRaw === 'string'
//         ? firstGoalRaw
//         : (firstGoalRaw?.value ?? null);
//     const firstGoalResult = (typeof firstGoalRaw === 'object' && firstGoalRaw !== null)
//         ? firstGoalRaw
//         : null;
//     const firstGoal = firstGoalValue;


//     if (loading) return (
//         <div className={classes.page}>
//             <div className={classes.loaderScreen}><SmallLoader /></div>
//         </div>
//     );

//     return (
//         <div className={classes.page}>

//             {/* ══ STICKY HEADER ══ */}
//             <div className={classes.stickyHeader}>

//                 {/* top nav */}
//                 <div className={classes.topNav}>
//                     <button className={classes.backBtn} onClick={() => navigate(-1)}>
//                         <FaArrowLeft />
//                     </button>
//                     <span className={classes.topNavTitle}>Match Winnings</span>
//                     <div style={{ width: 38 }} />
//                 </div>

//                 {/* match banner */}
//                 {winning && (
//                     <div className={classes.matchBanner}>
//                         <div className={classes.matchBannerGlow} />

//                         {/* league */}
//                         <div className={classes.leagueRow}>
//                             {winning.league_image && (
//                                 <img src={winning.league_image} alt={winning.league_name} className={classes.leagueImg} />
//                             )}
//                             <span className={classes.leagueName}>{winning.league_name}</span>
//                             <span className={classes.matchDate}>
//                                 {moment.utc(winning.match_date_time).local().format("DD MMM YYYY · HH:mm")}
//                             </span>
//                         </div>

//                         {/* teams + score */}
//                         <div className={classes.matchTeamsRow}>
//                             <div className={classes.matchTeam}>
//                                 <div className={classes.matchLogoRing}>
//                                     <img src={winning.home_team_image} alt={winning.home_team_name} className={classes.matchLogoImg} />
//                                 </div>
//                                 <span className={classes.matchTeamName}>{winning.home_team_name}</span>
//                             </div>

//                             <div className={classes.matchScoreBlock}>
//                                 {homeGoals !== null && awayGoals !== null ? (
//                                     <div className={classes.scoreRow}>
//                                         <span className={classes.scoreNum}>{homeGoals}</span>
//                                         <FaMinus className={classes.scoreDash} />
//                                         <span className={classes.scoreNum}>{awayGoals}</span>
//                                     </div>
//                                 ) : (
//                                     <span className={classes.ftBadge}>FT</span>
//                                 )}
//                                 <span className={classes.ftLabel}>Full Time</span>
//                             </div>

//                             <div className={classes.matchTeam}>
//                                 <div className={classes.matchLogoRing}>
//                                     <img src={winning.away_team_image} alt={winning.away_team_name} className={classes.matchLogoImg} />
//                                 </div>
//                                 <span className={classes.matchTeamName}>{winning.away_team_name}</span>
//                             </div>
//                         </div>

//                         {/* venue */}
//                         {winning.match_venue_name && (
//                             <span className={classes.venueRow}>
//                                 📍 {winning.match_venue_name}{winning.match_venue_city ? `, ${winning.match_venue_city}` : ""}
//                             </span>
//                         )}
//                     </div>
//                 )}
//             </div>

//             {/* ══ CONTENT ══ */}
//             <div className={classes.content}>

//                 <div className={classes.tabsRow}>
//                     {[
//                         { key: "winnings", label: "Winninigs" },
//                         { key: "predictions", label: "Predictions" },
//                     ].map(t => (
//                         <button
//                             key={t.key}
//                             type="button"
//                             className={`${classes.tabBtn} ${tab === t.key ? classes.tabBtnActive : ""}`}
//                             onClick={() => setTab(t.key)}
//                         >
//                             {t.label}
//                             {tab === t.key && <span className={classes.tabUnderline} />}
//                         </button>
//                     ))}
//                 </div>

//                 {tab === "predictions" ? (
//                     <div className={classes.predsPanel}>

//                         {predictions.length === 0 ? (
//                             <div className={classes.emptyState}>
//                                 <span>🎯</span>
//                                 <p>No predictions found.</p>
//                             </div>
//                         ) : (
//                             <>
//                                 {/* ── 1. Goal Scorers ── */}
//                                 {scorers.length > 0 && (
//                                     <div className={classes.predCard}>
//                                         <div className={classes.predCardHead}>
//                                             <span className={classes.predCardEmoji}>⚽</span>
//                                             <div>
//                                                 <p className={classes.predCardTitle}>Goal Scorers</p>
//                                                 <p className={classes.predCardSub}>Players you predicted to score</p>
//                                             </div>
//                                         </div>
//                                         <div className={classes.scorersList}>
//                                             {scorers.map((scorer, i) => (
//                                                 <div key={scorer.id ?? i} className={classes.scorerRow}>
//                                                     <div className={classes.scorerAvatar}>
//                                                         {scorer.photo
//                                                             ? <img src={scorer.photo} alt={scorer.name} className={classes.scorerAvatarImg} />
//                                                             : <span className={classes.scorerAvatarNum}>{scorer.number ?? (i + 1)}</span>
//                                                         }
//                                                         <span className={classes.scorerBadge}>{i + 1}</span>
//                                                     </div>
//                                                     <div className={classes.scorerInfo}>
//                                                         <span className={classes.scorerName}>{scorer.name ?? '—'}</span>
//                                                         {scorer.team && <span className={classes.scorerTeam}>{scorer.team}</span>}
//                                                     </div>
//                                                     {/* result if available */}
//                                                     {scorer.message !== undefined && scorer.message !== "" && (
//                                                         <div className={`${classes.scorerResult} ${scorer.point > 0 ? classes.scorerResultWin : classes.scorerResultLoss}`}>
//                                                             {scorer.point > 0 ? <FaCheck /> : "✗"}
//                                                             <span>+{scorer.point ?? 0} pts</span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* ── 2. First Goal Time ── */}
//                                 {firstGoal && (
//                                     <div className={classes.predCard}>
//                                         <div className={classes.predCardHead}>
//                                             <span className={classes.predCardEmoji}>⏱</span>
//                                             <div>
//                                                 <p className={classes.predCardTitle}>First Goal Time</p>
//                                                 <p className={classes.predCardSub}>When you predicted the first goal</p>
//                                             </div>
//                                         </div>
//                                         <div className={classes.predAnswer}>
//                                             <span className={classes.predAnswerText}>
//                                                 {GOAL_TIME_LABELS[firstGoal] ?? firstGoal}
//                                             </span>
//                                         </div>
//                                         {/* result feedback after match ends */}
//                                         {firstGoalResult?.message && (
//                                             <div className={`${classes.predResult} ${firstGoalResult.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
//                                                 <span>{firstGoalResult.message}</span>
//                                                 <span className={classes.predResultPts}>+{firstGoalResult.point ?? 0} pts</span>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}

//                                 {/* ── 3. Halftime Score ── */}
//                                 {halfTime && (
//                                     <div className={classes.predCard}>
//                                         <div className={classes.predCardHead}>
//                                             <span className={classes.predCardEmoji}>🔔</span>
//                                             <div>
//                                                 <p className={classes.predCardTitle}>Halftime Score</p>
//                                                 <p className={classes.predCardSub}>Your predicted score at the break</p>
//                                             </div>
//                                         </div>

//                                         <div className={classes.htScoreDisplay}>
//                                             {/* home side */}
//                                             <div className={classes.htScoreTeam}>
//                                                 {halfTime.homeTeamImage && (
//                                                     <img src={halfTime.homeTeamImage} alt="" className={classes.htScoreLogo} />
//                                                 )}
//                                                 <span className={classes.htScoreTeamName}>{halfTime.homeTeamName}</span>
//                                             </div>

//                                             <div className={classes.htScoreNums}>
//                                                 <span className={classes.htScoreNum}>{halfTime.homeTeamScore}</span>
//                                                 <span className={classes.htScoreDash}>–</span>
//                                                 <span className={classes.htScoreNum}>{halfTime.awayTeamScore}</span>
//                                             </div>

//                                             {/* away side */}
//                                             <div className={`${classes.htScoreTeam} ${classes.htScoreTeamRight}`}>
//                                                 {halfTime.awayTeamImage && (
//                                                     <img src={halfTime.awayTeamImage} alt="" className={classes.htScoreLogo} />
//                                                 )}
//                                                 <span className={classes.htScoreTeamName}>{halfTime.awayTeamName}</span>
//                                             </div>
//                                         </div>

//                                         {/* result feedback if available */}
//                                         {halfTime.message !== undefined && halfTime.message !== "" && (
//                                             <div className={`${classes.predResult} ${halfTime.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
//                                                 <span>{halfTime.message}</span>
//                                                 <span className={classes.predResultPts}>+{halfTime.point ?? 0} pts</span>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}

//                                 {/* ── 4. Match Winner ── */}
//                                 {winner && (
//                                     <div className={classes.predCard}>
//                                         <div className={classes.predCardHead}>
//                                             <span className={classes.predCardEmoji}>🏆</span>
//                                             <div>
//                                                 <p className={classes.predCardTitle}>Match Winner</p>
//                                                 <p className={classes.predCardSub}>Your predicted full-time result</p>
//                                             </div>
//                                         </div>

//                                         <div className={classes.winnerDisplay}>
//                                             {winner.teamName === 'Draw' ? (
//                                                 <div className={classes.winnerDrawRow}>
//                                                     <span className={classes.winnerDrawIcon}>🤝</span>
//                                                     <span className={classes.winnerName}>Draw</span>
//                                                 </div>
//                                             ) : (
//                                                 <div className={classes.winnerTeamRow}>
//                                                     {/* find logo from matchDetails */}
//                                                     {matchDetails && (
//                                                         <div className={classes.winnerLogoWrap}>
//                                                             <img
//                                                                 src={
//                                                                     winner.teamName === matchDetails.home_team_name
//                                                                         ? winning.home_team_image
//                                                                         : winning.away_team_image
//                                                                 }
//                                                                 alt={winner.teamName}
//                                                                 className={classes.winnerLogoImg}
//                                                             />
//                                                         </div>
//                                                     )}
//                                                     <span className={classes.winnerName}>{winner.teamName}</span>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* result feedback if available */}
//                                         {winner.message !== undefined && winner.message !== "" && (
//                                             <div className={`${classes.predResult} ${winner.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
//                                                 <span>{winner.message}</span>
//                                                 <span className={classes.predResultPts}>+{winner.point ?? 0} pts</span>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </>
//                         )}
//                     </div>
//                 ) : (
//                 <>
//                     {/* ── USER WINNING CARD ── */}
//                     {winning ? (
//                         <div className={`${classes.winCard} ${rank?.gold ? classes.winCardGold : ""}`}>

//                             {/* card header */}
//                             <div className={classes.winCardHead}>
//                                 <FaTrophy className={`${classes.winCardTrophyIcon} ${rank?.gold ? classes.trophyGold : classes.trophyDefault}`} />
//                                 <div>
//                                     <p className={classes.winCardTitle}>Your Result</p>
//                                     <p className={classes.winCardSub}>
//                                         Ranked out of {winning.users_joined?.toLocaleString() ?? "—"} participants
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* rank + points */}
//                             <div className={classes.winCardBody}>
//                                 <div className={classes.winStat}>
//                                     <span className={classes.winStatBig}>
//                                         {rank?.emoji ?? ""} {rank?.label}
//                                     </span>
//                                     <span className={classes.winStatLabel}>Your Rank</span>
//                                 </div>

//                                 <div className={classes.winStatDivider} />

//                                 <div className={classes.winStat}>
//                                     <span className={classes.winStatBig}>
//                                         {Number(winning.total_points).toLocaleString()}
//                                     </span>
//                                     <span className={classes.winStatLabel}>Total Points</span>
//                                 </div>

//                                 <div className={classes.winStatDivider} />

//                                 <div className={classes.winStat}>
//                                     <span className={`${classes.rewardChip} ${winning.rewarded ? classes.rewardChipYes : classes.rewardChipNo}`}>
//                                         {winning.rewarded ? "Rewarded" : "Pending"}
//                                     </span>
//                                     <span className={classes.winStatLabel}>Gratification</span>
//                                 </div>
//                             </div>

//                             {/* message */}
//                             {winning.message && (
//                                 <div className={classes.winCardMessage}>
//                                     <span>🎉</span>
//                                     <span>{winning.message}</span>
//                                 </div>
//                             )}
//                         </div>
//                     ) : (
//                         <div className={classes.noWinCard}>
//                             <FaTrophy className={classes.noWinIcon} />
//                             <p className={classes.noWinTitle}>Not in Top 10</p>
//                             <p className={classes.noWinText}>You didn't finish in the top 10 for this match.</p>
//                         </div>
//                     )}

//                     {/* ── LEADERBOARD ── */}
//                     <div className={classes.section}>
//                         <p className={classes.sectionTitle}>🏆 Leaderboard</p>

//                         {/* user's rank highlight */}
//                         {userRank && (
//                             <div className={classes.userRankCard}>
//                                 <div className={classes.userRankLeft}>
//                                     <span className={classes.userRankMedal}>
//                                         {/* {MEDAL[userRank.user_rank] ?? `#${userRank.user_rank}`} */}
//                                         {MEDAL[winning.user_rank] ?? `#${winning.user_rank}`}
//                                     </span>
//                                     <div className={classes.userRankInfo}>
//                                         <span className={classes.userRankLabel}>Your Rank</span>
//                                         <span className={classes.userRankMsisdn}>{userRank.msisdn}</span>

//                                     </div>
//                                 </div>
//                                 <div className={classes.userRankPts}>
//                                     <span className={classes.userRankPtsNum}>{userRank.total_points}</span>
//                                     <span className={classes.userRankPtsLabel}>pts</span>
//                                 </div>
//                             </div>
//                         )}

//                         {/* table */}
//                         <div className={classes.lbTable}>
//                             <div className={classes.lbHead}>
//                                 <span className={classes.lbColRank}>Rank</span>
//                                 <span className={classes.lbColNumber}>Number</span>
//                                 <span className={classes.lbColPts}>Points</span>
//                             </div>

//                             {leaderboard.length === 0 ? (
//                                 <div className={classes.lbEmpty}>
//                                     <span>🏆</span>
//                                     <p>No leaderboard data yet.</p>
//                                 </div>
//                             ) : (
//                                 leaderboard.map((row, i) => (
//                                     <div
//                                         key={i}
//                                         className={`${classes.lbRow} ${userRank?.msisdn === row.msisdn ? classes.lbRowSelf : ""}`}
//                                     >
//                                         <span className={classes.lbColRank}>
//                                             {MEDAL[row.rank]
//                                                 ? <span>{MEDAL[row.rank]}</span>
//                                                 : <span className={classes.lbRankNum}>{row.rank}</span>
//                                             }
//                                         </span>
//                                         <span className={classes.lbColNumber}>{row.msisdn}</span>
//                                         <span className={classes.lbColPts}>{row.total_points}</span>
//                                     </div>
//                                 ))
//                             )}
//                         </div>
//                     </div>
//                 </>
//                 )}



//             </div>
//         </div>
//     );
// };

// export default MatchWinningsPage2;




import React, { useEffect, useState } from 'react';
import classes from "./MatchWinningsPage2.module.css";
import { FaArrowLeft, FaTrophy, FaMinus, FaCheck } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import { matchWinningsApi, getPredictionLeaderboardApi } from '../../http/http';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { useTranslation } from 'react-i18next';

/* ── helpers ── */
const safeParse = (raw, fb = null) => {
    try { return raw ? JSON.parse(raw) : fb; }
    catch { return fb; }
};

const MEDAL = { 1: "🥇", 2: "🥈", 3: "🥉" };

const getRankDisplay = (rank) => {
    if (rank === 1) return { emoji: "🥇", label: "1st Place", gold: true };
    if (rank === 2) return { emoji: "🥈", label: "2nd Place", gold: false };
    if (rank === 3) return { emoji: "🥉", label: "3rd Place", gold: false };
    return { emoji: null, label: `#${rank}`, gold: false };
};

const GOAL_TIME_LABELS = {
    "0-15": "0 – 15 min",
    "16-30": "16 – 30 min",
    "31-45": "31 – 45 min",
    "46-60": "46 – 60 min",
    "61-75": "61 – 75 min",
    "76-90": "76 – 90 min",
    "none": "No Goal",
};

const MatchWinningsPage2 = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userDetails } = useSelector(s => s?.persisted?.userSlice);

    const { t } = useTranslation();

    const [winning, setWinning] = useState(null);
    const [leaderboard, setLeaderboard] = useState([]);
    const [userRank, setUserRank] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState("winnings");
    const [predictions, setPredictions] = useState([]);

    const { selectedLanguage } = useSelector((state) => state.languageSlice);


    /* ── fetch ── */
    const fetchData = async () => {
        try {
            setLoading(true);
            const fixtureId = location?.state?.match_fixture_id;
            const [winRes, lbRes] = await Promise.all([
                matchWinningsApi(fixtureId, userDetails?.token),
                getPredictionLeaderboardApi(fixtureId, userDetails?.token),
            ]);
            const winData = winRes?.data;
            const row = Array.isArray(winData) ? winData[0] : winData;
            setWinning(row);
            setPredictions(safeParse(row?.predictions) ?? []);
            setLeaderboard(lbRes?.data?.leaderboard ?? []);
            setUserRank(lbRes?.data?.userRank?.[0] ?? null);
        } catch (e) {
            if (e?.response?.status === 403) {
                dispatch(removeUserDetails());
                toast.error(t("71"));
                navigate('/');
            } else {
                toast.error(e?.response?.data?.message || t("2"));
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (location?.state?.match_fixture_id) fetchData();
        else navigate(-1);
    }, [location?.state?.match_fixture_id]);

    /* ── derived ── */
    const matchDetails = safeParse(winning?.match_details);
    const homeGoals = matchDetails?.goals?.home ?? null;
    const awayGoals = matchDetails?.goals?.away ?? null;
    const rank = winning ? getRankDisplay(winning.user_rank) : null;

    const getPred = (key) => Array.isArray(predictions) ? predictions.find(p => p[key])?.[key] : null;
    const scorers = getPred('scorers') ?? [];
    const halfTime = getPred('halfTime') ?? null;
    const winner = getPred('winner') ?? null;

    const firstGoalRaw = getPred('firstGoal') ?? null;
    const firstGoalValue = typeof firstGoalRaw === 'string'
        ? firstGoalRaw : (firstGoalRaw?.value ?? null);
    const firstGoalResult = (typeof firstGoalRaw === 'object' && firstGoalRaw !== null)
        ? firstGoalRaw : null;
    const firstGoal = firstGoalValue;

    if (loading) return (
        <div className={classes.page}>
            <div className={classes.loaderScreen}><SmallLoader /></div>
        </div>
    );

    return (
        <div className={classes.page}>

            {/* ══ STICKY HEADER ══ */}
            <div className={classes.stickyHeader}>

                {/* top nav */}
                <div className={classes.topNav}>
                    <button className={classes.backBtn} onClick={() => navigate(-1)}>
                        <FaArrowLeft />
                    </button>
                    <span className={classes.topNavTitle}>{t("199")}</span>
                    <div style={{ width: 38 }} />
                </div>

                {/* match banner */}
                {winning && (
                    <div className={classes.matchBanner}>
                        <div className={classes.matchBannerGlow} />

                        <div className={classes.leagueRow}>
                            {winning.league_image && (
                                <img src={winning.league_image} alt={winning.league_name} className={classes.leagueImg} />
                            )}
                            <span className={classes.leagueName}>{winning.league_name}</span>
                            <span className={classes.matchDate}>
                                {moment.utc(winning.match_date_time).local().format("DD MMM YYYY · HH:mm")}
                            </span>
                        </div>

                        <div className={classes.matchTeamsRow}>
                            <div className={classes.matchTeam}>
                                <div className={classes.matchLogoRing}>
                                    <img src={winning.home_team_image} alt={winning.home_team_name} className={classes.matchLogoImg} />
                                </div>
                                <span className={classes.matchTeamName}>{winning.home_team_name}</span>
                            </div>

                            <div className={classes.matchScoreBlock}>
                                {homeGoals !== null && awayGoals !== null ? (
                                    <div className={classes.scoreRow}>
                                        <span className={classes.scoreNum}>{homeGoals}</span>
                                        <FaMinus className={classes.scoreDash} />
                                        <span className={classes.scoreNum}>{awayGoals}</span>
                                    </div>
                                ) : (
                                    <span className={classes.ftBadge}>{t("200")}</span>
                                )}
                                <span className={classes.ftLabel}>{t("201")}</span>
                            </div>

                            <div className={classes.matchTeam}>
                                <div className={classes.matchLogoRing}>
                                    <img src={winning.away_team_image} alt={winning.away_team_name} className={classes.matchLogoImg} />
                                </div>
                                <span className={classes.matchTeamName}>{winning.away_team_name}</span>
                            </div>
                        </div>

                        {winning.match_venue_name && (
                            <span className={classes.venueRow}>
                                📍 {winning.match_venue_name}{winning.match_venue_city ? `, ${winning.match_venue_city}` : ""}
                            </span>
                        )}
                    </div>
                )}

                {/* tabs */}
                <div className={classes.tabsRow}>
                    {[
                        { key: "winnings", label: t("202") },
                        { key: "predictions", label: t("203") },
                    ].map(t => (
                        <button
                            key={t.key}
                            type="button"
                            className={`${classes.tabBtn} ${tab === t.key ? classes.tabBtnActive : ""}`}
                            onClick={() => setTab(t.key)}
                        >
                            {t.label}
                            {tab === t.key && <span className={classes.tabUnderline} />}
                        </button>
                    ))}
                </div>
            </div>

            {/* ══ CONTENT ══ */}
            <div className={classes.content}>

                {/* ─── PREDICTIONS TAB ─── */}
                {tab === "predictions" && (
                    <div className={classes.predsPanel}>
                        {!Array.isArray(predictions) || predictions.length === 0 ? (
                            <div className={classes.emptyState}>
                                <span>🎯</span>
                                <p>{t("204")}</p>
                            </div>
                        ) : (
                            <>
                                {/* 1. Goal Scorers */}
                                {scorers.length > 0 && (
                                    <div className={classes.predCard}>
                                        <div className={classes.predCardHead}>
                                            <span className={classes.predCardEmoji}>⚽</span>
                                            <div>
                                                <p className={classes.predCardTitle}>{t("205")}</p>
                                                <p className={classes.predCardSub}>{t("206")}</p>
                                            </div>
                                        </div>
                                        <div className={classes.scorersList}>
                                            {scorers.map((scorer, i) => (
                                                <div key={scorer.id ?? i} className={classes.scorerRow}>
                                                    <div className={classes.scorerAvatar}>
                                                        {scorer.photo
                                                            ? <img src={scorer.photo} alt={scorer.name} className={classes.scorerAvatarImg} />
                                                            : <span className={classes.scorerAvatarNum}>{scorer.number ?? (i + 1)}</span>
                                                        }
                                                        <span className={classes.scorerBadge}>{i + 1}</span>
                                                    </div>
                                                    <div className={classes.scorerInfo}>
                                                        <span className={classes.scorerName}>{scorer.name ?? '—'}</span>
                                                        {scorer.team && <span className={classes.scorerTeam}>{scorer.team}</span>}
                                                    </div>
                                                    {scorer.message !== undefined && scorer.message !== "" && (
                                                        <div className={`${classes.scorerResult} ${scorer.point > 0 ? classes.scorerResultWin : classes.scorerResultLoss}`}>
                                                            {scorer.point > 0 ? <FaCheck /> : "✗"}
                                                            <span>+{scorer.point ?? 0} {t("176")}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* 2. First Goal */}
                                {firstGoal && (
                                    <div className={classes.predCard}>
                                        <div className={classes.predCardHead}>
                                            <span className={classes.predCardEmoji}>⏱</span>
                                            <div>
                                                <p className={classes.predCardTitle}>{t("207")}</p>
                                                <p className={classes.predCardSub}>{t("208")}</p>
                                            </div>
                                        </div>
                                        <div className={classes.predAnswer}>
                                            <span className={classes.predAnswerText}>
                                                {GOAL_TIME_LABELS[firstGoal] ?? firstGoal}
                                            </span>
                                        </div>
                                        {firstGoalResult?.message && (
                                            <div className={`${classes.predResult} ${firstGoalResult.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
                                                <span>{selectedLanguage == 0 ? firstGoalResult.message : firstGoalResult?.messageSwahili}</span>
                                                <span className={classes.predResultPts}>+{firstGoalResult.point ?? 0} {t("176")}</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* 3. Halftime */}
                                {halfTime && (
                                    <div className={classes.predCard}>
                                        <div className={classes.predCardHead}>
                                            <span className={classes.predCardEmoji}>🔔</span>
                                            <div>
                                                <p className={classes.predCardTitle}>{t("209")}</p>
                                                <p className={classes.predCardSub}>{t("210")}</p>
                                            </div>
                                        </div>
                                        <div className={classes.htScoreDisplay}>
                                            <div className={classes.htScoreTeam}>
                                                {halfTime.homeTeamImage && (
                                                    <img src={halfTime.homeTeamImage} alt="" className={classes.htScoreLogo} />
                                                )}
                                                <span className={classes.htScoreTeamName}>{halfTime.homeTeamName}</span>
                                            </div>
                                            <div className={classes.htScoreNums}>
                                                <span className={classes.htScoreNum}>{halfTime.homeTeamScore}</span>
                                                <span className={classes.htScoreDash}>–</span>
                                                <span className={classes.htScoreNum}>{halfTime.awayTeamScore}</span>
                                            </div>
                                            <div className={`${classes.htScoreTeam} ${classes.htScoreTeamRight}`}>
                                                {halfTime.awayTeamImage && (
                                                    <img src={halfTime.awayTeamImage} alt="" className={classes.htScoreLogo} />
                                                )}
                                                <span className={classes.htScoreTeamName}>{halfTime.awayTeamName}</span>
                                            </div>
                                        </div>
                                        {halfTime.message !== undefined && halfTime.message !== "" && (
                                            <div className={`${classes.predResult} ${halfTime.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
                                                <span>{selectedLanguage == 0 ? halfTime.message : halfTime?.messageSwahili}</span>
                                                <span className={classes.predResultPts}>+{halfTime.point ?? 0} {t("176")}</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* 4. Winner */}
                                {winner && (
                                    <div className={classes.predCard}>
                                        <div className={classes.predCardHead}>
                                            <span className={classes.predCardEmoji}>🏆</span>
                                            <div>
                                                <p className={classes.predCardTitle}>{t("211")}</p>
                                                <p className={classes.predCardSub}>{t("212")}</p>
                                            </div>
                                        </div>
                                        <div className={classes.winnerDisplay}>
                                            {winner.teamName === 'Draw' ? (
                                                <div className={classes.winnerDrawRow}>
                                                    <span className={classes.winnerDrawIcon}>🤝</span>
                                                    <span className={classes.winnerName}>{t("213")}</span>
                                                </div>
                                            ) : (
                                                <div className={classes.winnerTeamRow}>
                                                    {winning && (
                                                        <div className={classes.winnerLogoWrap}>
                                                            <img
                                                                src={winner.teamName === winning.home_team_name ? winning.home_team_image : winning.away_team_image}
                                                                alt={winner.teamName}
                                                                className={classes.winnerLogoImg}
                                                            />
                                                        </div>
                                                    )}
                                                    <span className={classes.winnerName}>{winner.teamName}</span>
                                                </div>
                                            )}
                                        </div>
                                        {winner.message !== undefined && winner.message !== "" && (
                                            <div className={`${classes.predResult} ${winner.point > 0 ? classes.predResultWin : classes.predResultLoss}`}>
                                                <span>{selectedLanguage == 0 ? winner.message : winner?.messageSwahili}</span>
                                                <span className={classes.predResultPts}>+{winner.point ?? 0} {t("176")}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}

                {/* ─── WINNINGS TAB ─── */}
                {tab === "winnings" && (
                    <>
                        {/* User winning card */}
                        {winning ? (
                            <div className={`${classes.winCard} ${rank?.gold ? classes.winCardGold : ""}`}>
                                <div className={classes.winCardHead}>
                                    <FaTrophy className={`${classes.winCardTrophyIcon} ${rank?.gold ? classes.trophyGold : classes.trophyDefault}`} />
                                    <div>
                                        <p className={classes.winCardTitle}>{t("214")}</p>
                                        <p className={classes.winCardSub}>
                                            {t("215")} {winning.users_joined?.toLocaleString() ?? "—"} {t("216")}
                                        </p>
                                    </div>
                                </div>
                                <div className={classes.winCardBody}>
                                    <div className={classes.winStat}>
                                        <span className={classes.winStatBig}>{rank?.emoji ?? ""} {rank?.label}</span>
                                        <span className={classes.winStatLabel}>{t("217")}</span>
                                    </div>
                                    <div className={classes.winStatDivider} />
                                    <div className={classes.winStat}>
                                        <span className={classes.winStatBig}>{Number(winning.total_points).toLocaleString()}</span>
                                        <span className={classes.winStatLabel}>{t("218")}</span>
                                    </div>
                                    <div className={classes.winStatDivider} />
                                    <div className={classes.winStat}>
                                        <span className={`${classes.rewardChip} ${winning.rewarded ? classes.rewardChipYes : classes.rewardChipNo}`}>
                                            {winning.rewarded ? t("219") : t("220")}
                                        </span>
                                        <span className={classes.winStatLabel}>{t("221")}</span>
                                    </div>
                                </div>
                                {winning.message && (
                                    <div className={classes.winCardMessage}>
                                        <span>🎉</span>
                                        <span>{winning.message}</span>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className={classes.noWinCard}>
                                <FaTrophy className={classes.noWinIcon} />
                                <p className={classes.noWinTitle}>{t("222")}</p>
                                <p className={classes.noWinText}>{t("223")}</p>
                            </div>
                        )}

                        {/* Leaderboard */}
                        <div className={classes.section}>
                            <p className={classes.sectionTitle}>{t("224")}</p>
                            {userRank && (
                                <div className={classes.userRankCard}>
                                    <div className={classes.userRankLeft}>
                                        <span className={classes.userRankMedal}>
                                            {winning ? (MEDAL[winning.user_rank] ?? `#${winning.user_rank}`) : ""}
                                        </span>
                                        <div className={classes.userRankInfo}>
                                            <span className={classes.userRankLabel}>{t("225")}</span>
                                            <span className={classes.userRankMsisdn}>{userRank.msisdn}</span>
                                        </div>
                                    </div>
                                    <div className={classes.userRankPts}>
                                        <span className={classes.userRankPtsNum}>{userRank.total_points}</span>
                                        <span className={classes.userRankPtsLabel}>{t("176")}</span>
                                    </div>
                                </div>
                            )}
                            <div className={classes.lbTable}>
                                <div className={classes.lbHead}>
                                    <span className={classes.lbColRank}>{t("226")}</span>
                                    <span className={classes.lbColNumber}>{t("227")}</span>
                                    <span className={classes.lbColPts}>{t("228")}</span>
                                </div>
                                {leaderboard.length === 0 ? (
                                    <div className={classes.lbEmpty}>
                                        <span>🏆</span>
                                        <p>{t("229")}</p>
                                    </div>
                                ) : (
                                    leaderboard.map((row, i) => (
                                        <div
                                            key={i}
                                            className={`${classes.lbRow} ${userRank?.msisdn === row.msisdn ? classes.lbRowSelf : ""}`}
                                        >
                                            <span className={classes.lbColRank}>
                                                {MEDAL[row.rank]
                                                    ? <span>{MEDAL[row.rank]}</span>
                                                    : <span className={classes.lbRankNum}>{row.rank}</span>
                                                }
                                            </span>
                                            <span className={classes.lbColNumber}>{row.msisdn}</span>
                                            <span className={classes.lbColPts}>{row.total_points}</span>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </>
                )}

            </div>

            {/* ══ STICKY BOTTOM BUTTON ══ */}
            {winning && (
                <div className={classes.stickyBottom}>
                    <button
                        className={classes.infoBtn}
                        onClick={() => navigate("/match-winnings-info", {
                            state: {
                                user_rank: winning.user_rank,
                                total_points: winning.total_points,
                                users_joined: winning.users_joined,
                                rewarded: winning.rewarded,
                                message: winning.message,
                                home_team_name: winning.home_team_name,
                                home_team_image: winning.home_team_image,
                                away_team_name: winning.away_team_name,
                                away_team_image: winning.away_team_image,
                                league_name: winning.league_name,
                                match_date_time: winning.match_date_time,
                            }
                        })}
                    >
                        <span className={classes.infoBtnIcon}>🎁</span>
                        <span className={classes.infoBtnText}>{t("230")}</span>
                        <span className={classes.infoBtnArrow}>›</span>
                    </button>
                </div>
            )}

        </div>
    );
};

export default MatchWinningsPage2;